// ----------------------------------------------------------------------

export default function Paper(theme) {
  if (theme.mode === 'light') return {};

  return {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(40, 40, 40, 0.8) !important", // Adjust transparency
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(255, 255, 255, 0.9) !important", // Ensure Alert background is not affected
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },

      variants: [
        {
          props: { variant: 'outlined' },
          style: { borderColor: theme.palette.grey[500_12] },
        },
      ],

      styleOverrides: {
        root: {
          background: "hsla(0, 0%, 5%, .2)", /* Balanced darkness */
          backdropFilter: "blur(10px) ", 
          "-webkit-backdrop-filter": "blur(10px) ", // Safari support

        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          background: "hsla(0, 0%, 5%, .8)", // darker or more opaque
          backdropFilter: "blur(10px)", // stronger blur
          WebkitBackdropFilter: "blur(10px)", // Safari
        },
      },
    },

  };
}
